export default [
  'INIT',
  'UPLOAD_HANDOUTS',
  'REMOVE_HANDOUT',
  'FETCH_HANDOUTS_SUCCESS',
  'FETCH_HANDOUTS_FAILURE',
  'UPLOADER_STATE_UPDATE',
  'REALTIME_FILE_UPLOADED',
  ['UPLOAD_PROGRESS_UPDATED', 'fileName', 'percent'],
  'RESET_STORE_DATA',
]
